import { createNewSelectItemRenderer as createNewItemRenderer } from 'vet-bones/components';
import { SelectItem } from 'vet-bones/utils/select';

import * as copy from 'src/templates/copy';

export const createNewSelectItemRenderer = createNewItemRenderer<
  null,
  SelectItem<null>
>({
  createText: copy.components.defaults.itemSelectorCreate,
  allowDuplicates: true,
});
